export default __webpack_public_path__ + "static/media/Rectangle 358 (1).cdbdf68f.png";